//@ts-ignore
import React, { useState } from 'react';
import { CategoriesStyled, CategorySpan } from './styled';

export const ReelCategories = ({ reelCategories, reels, setReelsState }: any) => {
  const [activeCategory, setActiveCategory] = useState<number | null>(null);

  const filterReel = (categoryId: number) => {
    setReelsState(
      reels.map((r: any) => {
        r.hide = false;
        if (r.categoryId !== categoryId && activeCategory !== categoryId) {
          r.hide = true;
        }
        return r;
      }),
    );
    setActiveCategory(activeCategory !== categoryId ? categoryId : null);
  };

  return (
    <CategoriesStyled id="reel-categories">
      <div className="scroll-div d-flex">
        {reelCategories.map((c: any, i: number) => (
          <CategorySpan
            key={i}
            onClick={() => filterReel(c.id)}
            activeCategory={activeCategory ?? c.id}
            id={c.id}
          >
            {c.title}
          </CategorySpan>
        ))}
      </div>
    </CategoriesStyled>
  );
};
